module.exports = __webpack_public_path__ + "static/media/python.86b8f5fd.svg";